<template>
    <SpacingClassWrapper
        :padding-bottom="$mq | mq({ sm: 0, pccFullSize: 0 })"
        :margin-bottom="$mq | mq({ sm: 0, pccFullSize: 0 })"
        :margin-left="$mq | mq({ sm: 0, pccFullSize: 4 })"
    >
        <FlexContainer
            :flex-direction="flexDirection.column"
            :justify-content="flexJustifyContent.spaceBetween"
            :flex-basis="$mq | mq({ sm: 100, pccFullSize: 20 })"
        >
            <FlexClassWrapper
                :justify-content="flexJustifyContent.center"
            >
                <SpacingClassWrapper
                    :margin-bottom="$mq | mq({
                        sm: 0,
                        pccFullSize: 0
                    })"
                    :padding-y="$mq | mq({
                        sm: 2,
                        pccFullSize: 2
                    })"
                >
                    <Button
                        :width="$mq | mq({
                            sm: buttonWidth.baseWidth,
                            pccFullSize: buttonWidth.wide
                        })"
                        :height="$mq | mq({
                            sm:buttonHeight.baseHeight,
                            pccFullSize: buttonHeight.high
                        })"
                        :color="buttonColors.orange"
                        type="submit"
                        :disabled="inProgress"
                        :id="calculateId"
                    >
                        <FlexContainer
                            v-if="inProgress"
                            :justify-content="flexJustifyContent.center"
                        >
                            <Loader
                                :size="loaderSizes.small"
                                :color="loaderIndicatiorColor.secondary"
                            />
                        </FlexContainer>
                        <Typography
                            v-else
                            :varaint="typographyVariants.caption"
                            :size="typographySizes.body"
                            :color="typographyColors.white"
                            :weight="typographyWeights.bold"
                            :transform="typographyTransform.uppercase"
                        >
                            {{ $mq | mq({ sm: t('form.btn.calculate'), pccFullSize: t('form.btn.calculate') }) }}
                        </Typography>
                    </Button>
                </SpacingClassWrapper>
                <SpacingClassWrapper
                    :padding-left="3"
                    :padding-right="1"
                    :padding-y="2"
                    :margin-top="4"
                >
                    <Button
                        :color="buttonColors.primary"
                        :variant="buttonVariants.outlined"
                        @click="$emit('download-click')"
                        :id="downloadId"
                    >
                        <Typography
                            :variant="typographyVariants.caption"
                            :size="typographySizes.body"
                            :color="typographyColors.primary"
                            :weight="typographyWeights.bold"
                            :transform="typographyTransform.uppercase"
                        >
                          {{ t('header.downloadButton') }}
                        </Typography>
                        <SpacingClassWrapper
                            :margin-left="1"
                        >
                            <img src="/wp-content/themes/cardschat/tools/chips-calculator/src/plugin/assets/img/icon-download.svg" width="20" height="20" alt="download icon" aria-hidden="true">
                        </SpacingClassWrapper>
                    </Button>
                </SpacingClassWrapper>
                <SpacingClassWrapper
                    :margin-top="4"
                    :padding-x="4"
                    :padding-y="2"
                >
                    <Button
                        :width="$mq | mq({
                            sm: buttonWidth.baseWidth,
                            pccFullSize: buttonWidth.wide
                        })"
                        :height="$mq | mq({
                            sm:buttonHeight.baseHeight,
                            pccFullSize: buttonHeight.high
                        })"
                        :color="buttonColors.primary"
                        :variant="buttonVariants.text"
                        type="reset"
                        :id="resetId"
                    >
                        <Typography
                            :varaint="typographyVariants.caption"
                            :size="typographySizes.body"
                            :color="typographyColors.primary"
                            :weight="typographyWeights.bold"
                            :transform="typographyTransform.uppercase"
                        >
                            {{ t('form.btn.reset') }}
                        </Typography>
                    </Button>
                </SpacingClassWrapper>
            </FlexClassWrapper>
        </FlexContainer>
    </SpacingClassWrapper>
</template>

<script>
// Components
import Button from '../../components/Button';
import Typography from '../../components/Typography';
import Loader from '../../components/Loader';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';
import FlexClassWrapper from '../../classWrappers/FlexClassWrapper';

// Containers
import FlexContainer from '../flex/FlexContainer';

// Mixins
import styles from '../../mixins/styles';
import translations from '../../mixins/translations';

// Types
import {
    buttonVariants,
    buttonColors,
    buttonWidth,
    defaultButtonWidth,
    buttonHeight,
    defaultButtonHeight
} from '../../types/Button.types';
import {
    typographyVariants,
    typographySizes,
    typographyColors,
    typographyWeights,
    typographyTransform
} from '../../types/Typography.types';
import {
    flexDirection,
    flexAlignSelf,
    flexJustifyContent
} from '../../types/Flex.types';
import {
    loaderSizes,
    loaderIndicatiorColor
} from '../../types/Loader.types';

// Config Data
import {
  calculateId,
  downloadId,
  resetId
} from '../../config/form/'

export default {
    name: 'FormButtonsContainer',
    components: {
        // Components
        Button,
        Typography,
        Loader,
        // Class Wrappers
        SpacingClassWrapper,
        FlexClassWrapper,
        // Containers
        FlexContainer
    },
    mixins: [styles, translations],
    props: {
        inProgress: {
            type: Boolean,
            default: false,
        }
    },
    data: function () {
        return {
            // Types
            buttonVariants,
            buttonColors,
            buttonWidth,
            defaultButtonWidth,
            buttonHeight,
            defaultButtonHeight,
            typographyVariants,
            typographyTransform,
            typographySizes,
            typographyColors,
            typographyWeights,
            flexDirection,
            flexAlignSelf,
            flexJustifyContent,
            loaderSizes,
            loaderIndicatiorColor,
            calculateId,
            resetId,
            downloadId
        }
    },
}
</script>